module.exports = "//cdn.mxpnl.com/static/asset-cache/6c98abfdc586832f6ea1905fcf4910bb/iron/common/widgets/demo-selector-modal/assets/icons/Social.svg";